import React, { useContext, useEffect, useState } from "react";
import {
  Modal,
  Card,
  Form,
  Row,
  Col,
  Button,
  Container,
} from "react-bootstrap";

import classNames from "classnames";

import Select from "react-select";
import { useForm, Controller } from "react-hook-form";
import { Context } from "../../../utils/context";
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";

const AddOffCanvance = (props) => {
  const { postData, getData, Select2Data } = useContext(Context);

  const [products, setProducts] = useState([]);
  const [discountType, setDiscountType] = useState("");
  const [showModal, setShowModal] = useState({ code: 0, message: "" });

  const {
    control,
    register,
    handleSubmit,
    reset,
    formState: { errors },
    setValue,
  } = useForm();

  const getProducts = async () => {
    const res = await getData("/all-seller-products");
    if (res?.success) {
      const formatted = await Select2Data(res.data, "product_id");
      setProducts(formatted);
    }
  };

  useEffect(() => {
    if (props.show) {
      getProducts();
    }
  }, [props.show]);

  const onSubmit = async (data) => {
    const fd = new FormData();

    fd.append("product_id", data.product_id.value);
    fd.append("discount_type", data.discount_type);
    fd.append("discount", data.discount);
    fd.append("message", data.message || "");

    const res = await postData("/offerproduct", fd);

    setShowModal({ code: res.code, message: res.message });

    if (res.success) {
      reset();
    }
    setTimeout(() => props.handleClose(), 1000);
  };

  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={props.handleClose}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Add Offer Product
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Card className="shadow">
            <Card.Body>
              <Form onSubmit={handleSubmit(onSubmit)}>
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Product <span className="text-danger">*</span>
                      </Form.Label>
                      <Controller
                        name="product_id"
                        control={control}
                        rules={{ required: "Product is required" }}
                        render={({ field }) => (
                          <Select
                            {...field}
                            options={products}
                            placeholder="Select Product"
                            isClearable
                          />
                        )}
                      />
                      {errors.product_id && (
                        <small className="text-danger">
                          {errors.product_id.message}
                        </small>
                      )}
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Discount Type <span className="text-danger">*</span>
                      </Form.Label>

                      <Form.Select
                        {...register("discount_type", {
                          required: "Discount Type is required",
                        })}
                        className={classNames("", {
                          "is-invalid": errors?.discount_type,
                        })}
                        defaultValue=""
                      >
                        <option value="" disabled>
                          Select Type
                        </option>
                        <option value="percentage">Percentage (%)</option>
                        <option value="fixedamount">Fixed Amount</option>
                      </Form.Select>

                      {errors?.discount_type && (
                        <span className="text-danger">
                          {errors.discount_type.message}
                        </span>
                      )}
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        {discountType === "percentage"
                          ? "Discount (%)"
                          : discountType === "fixedamount"
                            ? "Discount Amount"
                            : "Discount"}{" "}
                        <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="number"
                        step="0.01"
                        placeholder="Enter discount"
                        {...register("discount", {
                          required: "Discount is required",
                          validate: (value) =>
                            discountType === "percentage" && value > 100
                              ? "Percentage cannot exceed 100"
                              : true,
                        })}
                      />
                      {errors.discount && (
                        <small className="text-danger">
                          {errors.discount.message}
                        </small>
                      )}
                    </Form.Group>
                  </Col>

                  <Col md={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>Message (Optional)</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={3}
                        placeholder="Enter offer message"
                        {...register("message")}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row className="mt-4">
                  <Col className="text-center">
                    <CancelButton
                      name="Cancel"
                      handleClose={props.handleClose}
                    />
                    <SaveButton
                      name="Save"
                      handleSubmit={handleSubmit(onSubmit)}
                    />
                  </Col>
                </Row>
              </Form>
            </Card.Body>
          </Card>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={!!showModal.code}
      />
    </>
  );
};

export default AddOffCanvance;
